import { ENDPOINT } from "../../constants/endpoint.js"
import axios from 'axios'
import Swal from "sweetalert2";
import router from '../../router'
import moment from "moment";

const state = {
  loading: false,
  notifications: [],
  notificationsAll: {},
};

const mutations = {
  LOADING: (state, payload) => {
    state.loading = payload.loading
  },
  SET_NOTIFICATION(state, notifications) {
    state.notifications = notifications;  
  },
  SET_NOTIFICATION_ALL(state, notifications) {
    state.notificationsAll = notifications;  
  },
}
const actions = {
  async getNotificationForNavbar({ commit }) {
    const url = ENDPOINT.GET_NOTIFICATION;
    await axios
      .get(url, {
        // params: {
        //   limit: data.limit
        // },
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
        }
      })
      .then(async(response) => {
        console.log("getNotificationForNavbar .data ", response.data);
        await commit("SET_NOTIFICATION", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  async getNotificationAll({ commit }) {
    const url = ENDPOINT.GET_NOTIFICATION_All;
    await axios
      .get(url, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
        }
      })
      .then(async(response) => {
        // console.log("response.data >>> ", response.data);
        const data = response.data.notifications
        await commit("SET_NOTIFICATION_ALL", data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  sendNotificationToApplication({ commit }, notificationReq) {
    const url = ENDPOINT.SEND_NOTIFICATION;
    const headers =  {
      "content-type": "multipart/form-data",
      "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
    }

    axios
      .post(url, notificationReq)
      .then(async(response) => {
        console.log("response.data ", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  updateActiveNotification({ commit }, id) {
    const url = ENDPOINT.GET_NOTIFICATION;
    const headers =  {
      "content-type": "multipart/form-data",
      "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
    }

    axios
      .put(`${url}/${id}`)
      .then(async(response) => {
        console.log("response.data ", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  readAll({ commit }) {
    const url = ENDPOINT.READ_NOTIFICATION_All;
    const headers =  {
      "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
    }

    axios
      .post(url,)
      .then(async(response) => {
        console.log("response.data ", response.data.data);
        await commit("SET_NOTIFICATION_ALL", response.data.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
